import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/meteologica.png'
import _imports_1 from '../assets/sunMoon.png'


const _withScopeId = n => (_pushScopeId("data-v-03018e7b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logoTopLeft" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      class: "logoWeather",
      alt: "logoWeather"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "logoSunMoon",
      src: _imports_1,
      alt: ""
    })
  ])
], -1))
const _hoisted_2 = {
  key: 0,
  class: "itemsNavbar"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, [
  /*#__PURE__*/_createElementVNode("i", null, "ES | °C ")
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "modal-overlay"
}
const _hoisted_6 = { class: "modal" }
const _hoisted_7 = { class: "modal-header" }
const _hoisted_8 = { class: "modal-content" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "°C -> °F No disponible", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Resetear subscripción", -1))
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ThemeSwitcher = _resolveComponent("ThemeSwitcher")!

  return (_openBlock(), _createElementBlock("header", null, [
    _hoisted_1,
    (_ctx.isMenuOpen)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/future" }, {
              default: _withCtx(() => [
                _createTextVNode("💻 Quiénes Somos")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/future" }, {
              default: _withCtx(() => [
                _createTextVNode("🌕🌙 Qué Ofrecemos")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/future" }, {
              default: _withCtx(() => [
                _createTextVNode("⭐ Suscripciones")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/future" }, {
              default: _withCtx(() => [
                _createTextVNode("📞 Contáctanos")
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: "buttonMenu",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
    }, "Menú"),
    _createElementVNode("div", {
      class: "main",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleModal && _ctx.toggleModal(...args)))
    }, _hoisted_4),
    (_ctx.isModalOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                class: "close-button"
              }, "X")
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h2", null, [
                _createVNode(_component_ThemeSwitcher)
              ]),
              _hoisted_9,
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetPremium && _ctx.resetPremium(...args))),
                class: "resetSubscription"
              }, _hoisted_11)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}